<template>
    <form-row title="What Is Your Role?">
        <input-select
            class="w-full"
            name="account_user_role"
            v-model="selected_role"
            :options="roles"
            no_selection=""
            @input="$emit('change', selected_role)"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        role: {},
    },

    data() {
        return {
            selected_role: this.role,
            roles: [
                {
                    value: 'agent_or_broker',
                    label: 'Agent or Broker',
                },
                {
                    value: 'attorney',
                    label: 'Attorney',
                },
                {
                    value: 'mortgage_broker',
                    label: 'Mortgage Broker',
                },
                {
                    value: 'other',
                    label: 'Other',
                },
            ],
        }
    },
}
</script>
